export interface FontOption {
  name: string
  label: string
  family: string
  category: "sans-serif" | "serif" | "mono" | "display"
}

export const FONT_OPTIONS: FontOption[] = [
  { name: "inter", label: "Inter", family: "'Inter', system-ui, sans-serif", category: "sans-serif" },
  { name: "dm-sans", label: "DM Sans", family: "'DM Sans', sans-serif", category: "sans-serif" },
  { name: "plus-jakarta", label: "Plus Jakarta Sans", family: "'Plus Jakarta Sans', sans-serif", category: "sans-serif" },
  { name: "source-sans", label: "Source Sans 3", family: "'Source Sans 3', sans-serif", category: "sans-serif" },
  { name: "nunito", label: "Nunito", family: "'Nunito', sans-serif", category: "sans-serif" },
  { name: "lora", label: "Lora", family: "'Lora', serif", category: "serif" },
  { name: "merriweather", label: "Merriweather", family: "'Merriweather', serif", category: "serif" },
  { name: "libre-baskerville", label: "Libre Baskerville", family: "'Libre Baskerville', serif", category: "serif" },
  { name: "playfair", label: "Playfair Display", family: "'Playfair Display', serif", category: "display" },
  { name: "space-grotesk", label: "Space Grotesk", family: "'Space Grotesk', sans-serif", category: "sans-serif" },
]

export const FONT_OPTIONS_BY_NAME: Record<string, FontOption> = Object.fromEntries(
  FONT_OPTIONS.map((f) => [f.name, f])
)

export function getFontOption(name: string): FontOption {
  return FONT_OPTIONS_BY_NAME[name] || FONT_OPTIONS[0]
}

export interface FontPairing {
  name: string
  label: string
  heading: string
  body: string
  description: string
}

export const FONT_PAIRINGS: FontPairing[] = [
  { name: "default", label: "Clean Modern", heading: "inter", body: "inter", description: "Inter for everything" },
  { name: "editorial", label: "Editorial", heading: "playfair", body: "source-sans", description: "Playfair Display + Source Sans" },
  { name: "warm-serif", label: "Warm Serif", heading: "merriweather", body: "source-sans", description: "Merriweather + Source Sans" },
  { name: "classic", label: "Classic", heading: "libre-baskerville", body: "inter", description: "Libre Baskerville + Inter" },
  { name: "geometric", label: "Geometric", heading: "space-grotesk", body: "dm-sans", description: "Space Grotesk + DM Sans" },
  { name: "friendly", label: "Friendly", heading: "nunito", body: "nunito", description: "Nunito for everything" },
  { name: "elegant", label: "Elegant", heading: "playfair", body: "lora", description: "Playfair Display + Lora" },
  { name: "minimal", label: "Minimal", heading: "dm-sans", body: "dm-sans", description: "DM Sans for everything" },
  { name: "literary", label: "Literary", heading: "lora", body: "merriweather", description: "Lora + Merriweather" },
  { name: "bold-modern", label: "Bold Modern", heading: "plus-jakarta", body: "inter", description: "Plus Jakarta Sans + Inter" },
  { name: "soft", label: "Soft", heading: "plus-jakarta", body: "nunito", description: "Plus Jakarta Sans + Nunito" },
  { name: "technical", label: "Technical", heading: "space-grotesk", body: "source-sans", description: "Space Grotesk + Source Sans" },
]
